import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardMedia, Grid } from '@mui/material';
import { useData } from '../../../contexts';
import { MdClose, MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { ScatterChartHighlightAndZoom } from '../../ScatterChart/ScatterChartHighlighAndZoom';
import { SitueringTableMobile } from './SitueringTableMobile';
import { SelectionPanel } from '../InsightsSynthesisSelectionPanel/SelectionMenuComponents/SelectionPanel';
import { InfoPanelOther } from '../../InfoPanelCluster/InfoPanelOther';

export const SitueringMobile = (props: any) => {
  const {
    data: propsData,
    pathInteractieveTool: pathInteractieveTool,
    toggled,
    open,
    setOpen,
    themas,
    indicatorThema,
    gemeenteLijst,
    benchmarkLijst,
    setBenchmarkLijst,
    d_ruimte,
    highlightedRow,
    setHighlightedRow,
    tableHighlightedRow,
    setTableHighlightedRow,
  } = props;

  const {
    selectedGemeente,
    selectedTopic,
    selectedBenchmarks,
    interfaceColor,
    barColors,
    locale,
    isZoomedInsights,
    setIsZoomedInsights,
    zoomFilters,
    setZoomFilters,
    selectedIndicatorsInzichten,
  } = useData();

  const id = 'Rangschikking';

  const xVar = 'rankNormalised';
  const xVarBench = 'rankNormalisedBench';
  const xVarTooltip = 'rank';
  const xVarTooltipBench = 'rankBench';
  const yVar = 'y';
  const zVar = 'z';

  const handleOpen = () => setOpen(true);

  useEffect(() => {
    toggled && handleOpen();
  }, [toggled]);

  const [dataTable, setDataTable] = useState(propsData);
  const [incomingData, setIncomingData] = useState([]) as any[];
  const [initialState, setInitialState] = useState({
    data: incomingData,
    left: 'dataMin',
    right: 'dataMax',
    refAreaLeft: '',
    refAreaRight: '',
    top: 'dataMax+1',
    bottom: 'dataMin-1',
    animation: true,
  }) as any[];

  const [zoomGraph, setZoomGraph] = useState(initialState);
  const [referenceAreas, setReferenceAreas] = useState([]) as any[];

  const zoomOut = (pageId: any) => {
    const data = propsData;

    const newData = data;
    const unique = [...new Set(newData.map((d: any) => d.id))];

    setZoomFilters((prev: any) => ({ ...prev, [pageId]: unique }));
    setIsZoomedInsights(false);

    setZoomGraph((prev: any) => ({
      ...prev,
      data: data?.slice(),
      refAreaLeft: '',
      refAreaRight: '',
      left: 'dataMin',
      right: 'dataMax',
      top: 'dataMax+1',
      bottom: 'dataMin-1',
    }));
  };

  useEffect(() => {
    setInitialState({
      data: propsData,
      left: 'dataMin',
      right: 'dataMax',
      refAreaLeft: '',
      refAreaRight: '',
      top: 'dataMax+1',
      bottom: 'dataMin-1',
      animation: true,
    });

    let sortedData = structuredClone(propsData);

    if (propsData.length !== 0) {
      sortedData = sortedData.sort((a: any, b: any) => {
        return a.rank - b.rank;
      });
    }

    setIncomingData(sortedData);
    zoomOut(id);
  }, [
    propsData,
    setIncomingData,
    setInitialState,
    selectedIndicatorsInzichten,
  ]);

  useEffect(() => {
    if (incomingData.length > 0) {
      // const max = Math.max(
      //   ...incomingData.map((o: any) => o[xVar]),
      // );
      const max = 100;
      const min: number = 0;
      const q1: number = max / 5;
      const q2: number = q1 * 2;
      const q3: number = q1 * 3;
      const q4: number = q1 * 4;

      const area1 = { id: 0, x1: min, x2: q1, color: '#adbec6' };
      const area2 = { id: 1, x1: q1, x2: q2, color: '#b5d9e9' };
      const area3 = { id: 2, x1: q2, x2: q3, color: '#c0eee1' };
      const area4 = { id: 3, x1: q3, x2: q4, color: '#EFCCB3' };
      const area5 = { id: 4, x1: q4, x2: max, color: '#D5B3BB' };

      const areas: any[] = [];
      areas.push(area1);
      areas.push(area2);
      areas.push(area3);
      areas.push(area4);
      areas.push(area5);

      setReferenceAreas(areas);
    }
  }, [incomingData, setReferenceAreas]);

  return (
    <Card className="card-borderless">
      <CardContent>
        <div
          className={'vl-typography'}
          style={{
            paddingLeft: '24px',
            paddingRight: '4px',
            marginBottom: '24px',
            marginRight: '16px',
          }}
        >
          <p className={'page-title-mobile'}>
            Waar situeert {selectedGemeente.label} zich ten opzichte van de
            andere Vlaamse gemeenten voor een indicator?
          </p>
          <p className={'page-subtitle-mobile'}>
            Onderstaande rangschikking per indicator is enkel opgemaakt voor de
            Vlaamse gemeenten, en niet voor andere benchmarks.
          </p>{' '}
          <div
            className={'vl-typography'}
            style={{
              float: 'right',
              // marginLeft: 'auto',
              marginTop: '16px',
              marginBottom: '28px',
              marginRight: '24px',
              cursor: 'pointer',
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingRight: '8px',
              paddingLeft: '8px',
              backgroundColor: interfaceColor,
              borderRadius: 12,
            }}
          >
            <p
              style={{
                color: 'white',
                textAlign: 'end',
                marginBottom: 0,
                fontSize: '11px',
              }}
              onClick={handleOpen}
            >
              Pas je selectie aan
            </p>
            <SelectionPanel
              open={open}
              setOpen={setOpen}
              themas={themas}
              indicatorThema={indicatorThema}
              gemeenteLijst={gemeenteLijst}
              selectedGemeente={selectedGemeente}
              selectedBenchmarks={selectedBenchmarks}
              benchmarkLijst={benchmarkLijst}
              setBenchmarkLijst={setBenchmarkLijst}
              d_ruimte={d_ruimte}
              isMobile={true}
            />
          </div>
          <div style={{ float: 'left' }}>
            <InfoPanelOther
              content={
                <>
                  <p>
                    Voor elke indicator rangschikken we alle Vlaamse gemeenten
                    van hoge naar lage waarden. Vervolgens bepalen we binnen die
                    rangschikking de positie van elke gemeente, van 1 (hoogste
                    waarde van alle gemeenten) tot maximaal 300 (laagste waarde
                    van alle gemeenten).
                  </p>
                  <br />
                  <p>
                    Deze figuur toont voor elke indicator wat de positie van de
                    gekozen gemeente is binnen het geheel van alle Vlaamse
                    gemeenten. Op die manier kan je voor verschillende
                    indicatoren vlot nagaan waar de gekozen gemeente zich
                    situeert ten opzichte van de benchmark.
                  </p>
                  <br />
                  <p>Aandachtspunten:</p>
                  <ul style={{ paddingLeft: 24 }}>
                    <li>
                      • Voor heel wat indicatoren zijn er niet voor alle 300
                      gemeenten data beschikbaar. Voor deze indicatoren loopt de
                      rangschikking bijgevolg niet van positie 1 tot en met
                      positie 300, maar bijvoorbeeld slechts tot positie 240. Om
                      de positie van een gemeente over indicatoren heen vlot te
                      kunnen vergelijken, tonen we in de figuur per indicator
                      een gestandaardiseerde positie. De originele positie is
                      dan herleid tot een positie op een schaal van 1 tot en met
                      100. Bv. positie 24/240 en 30/300 worden in de figuur
                      allebei gestandaardiseerd tot positie 10/100 en zijn aldus
                      vergelijkbaar.
                    </li>
                    <li>
                      • Enkel de Vlaamse gemeenten zijn opgenomen in de
                      rangschikking per indicator. Alle andere
                      gebiedsindelingen, die je ook al benchmark kan selecteren,
                      hebben geen positie binnen de rangschikking gekregen en
                      worden bijgevolg niet in de figuur getoond (bv. Vlaams
                      Gewest, provincie, referentieregio…).
                    </li>
                  </ul>
                  <br />
                  <p>
                    Wil je inzoomen op een aantal bolletjes/indicatoren binnen
                    de figuur? Selecteer binnen de balk van de gemeente het
                    gewenste bereik van bolletjes/indicatoren. Deze selectie van
                    indicatoren wordt vervolgens ook doorgetrokken naar de
                    andere figuren op de pagina.
                  </p>
                  <br />
                  <p>
                    Wil je de tabel anders sorteren? Je kan de tabel sorteren op
                    elk van de kolommen. Standaard is de tabel gesorteerd op de
                    kolom ‘Gemeente positie’.
                  </p>
                </>
              }
            />
          </div>
          <hr style={{ clear: 'both', marginRight: '12px' }} />
        </div>
      </CardContent>
      <CardMedia style={{ width: '100%' }}>
        {incomingData !== undefined && incomingData.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid
              item
              xs={12}
              sx={{
                height: '20px',
                maxHeight: '20px',
                paddingLeft: '50px',
                userSelect: 'none',
                fontSize: '0.8em',
                color: '#888',
              }}
            >
              <p>{selectedGemeente.ruimte}</p>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                height: '72px',
                maxHeight: '72px',
                paddingRight: '50px',
                userSelect: 'none',
                fontSize: '0.8em',
              }}
            >
              <ScatterChartHighlightAndZoom
                pageId={id}
                xAxisDataKey={xVar}
                yAxisDataKey={yVar}
                zAxisDataKey={zVar}
                xTooltip={xVarTooltip}
                labelGraph={selectedGemeente.ruimte}
                referenceAreas={referenceAreas}
                incomingData={incomingData}
                initialState={initialState}
                zoomGraph={zoomGraph}
                setZoomGraph={setZoomGraph}
                setIsZoomedInsights={setIsZoomedInsights}
                setDataTable={setDataTable}
                zoomFilters={zoomFilters}
                setZoomFilters={setZoomFilters}
                locale={locale}
                canZoom={true}
                highlightedRow={highlightedRow}
                setHighlightedRow={setHighlightedRow}
                isMobile={true}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: '20px',
                maxHeight: '20px',
                paddingLeft: '50px',
                userSelect: 'none',
                fontSize: '0.8em',
                color: '#888',
              }}
            >
              <p>{selectedBenchmarks[0].ruimte}</p>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                height: '72px',
                maxHeight: '72px',
                paddingRight: '50px',
                userSelect: 'none',
                fontSize: '0.8em',
              }}
            >
              <ScatterChartHighlightAndZoom
                pageId={id}
                xAxisDataKey={xVarBench}
                yAxisDataKey={yVar}
                zAxisDataKey={zVar}
                xTooltip={xVarTooltipBench}
                labelGraph={selectedBenchmarks[0].ruimte}
                referenceAreas={referenceAreas}
                incomingData={incomingData}
                initialState={initialState}
                zoomGraph={zoomGraph}
                setZoomGraph={setZoomGraph}
                setIsZoomedInsights={setIsZoomedInsights}
                setDataTable={setDataTable}
                zoomFilters={zoomFilters}
                setZoomFilters={setZoomFilters}
                locale={locale}
                canZoom={false}
                highlightedRow={highlightedRow}
                setHighlightedRow={setHighlightedRow}
                isMobile={true}
                isBench={true}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: '32px',
                maxHeight: '32px',
                paddingRight: '50px',
                paddingLeft: '8px',
              }}
            >
              <div
                style={{
                  whiteSpace: 'break-spaces',
                  fontSize: '13px',
                  paddingRight: '16px',
                }}
              >
                <ul>
                  {Object.keys(zoomFilters).map((d: any) => {
                    if (
                      zoomFilters[d].length !== 0 &&
                      zoomFilters[d].length !== incomingData.length
                    ) {
                      return (
                        <li
                          onClick={() => zoomOut(d)}
                          style={{
                            display: 'inline-block',
                            margin: 4,
                            marginTop: 8,
                            paddingLeft: 8,
                            paddingRight: 14,
                            backgroundColor: interfaceColor,
                            borderRadius: 24,
                            color: 'white',
                            cursor: 'pointer',
                            position: 'relative',
                            top: '-14px',
                          }}
                        >
                          {'Filter ' + d}
                          <span
                            style={{
                              fontWeight: 'bold',
                              position: 'relative',
                              top: 3,
                              left: 8,
                            }}
                          >
                            <MdClose />
                          </span>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                maxHeight: '514px',
                paddingRight: '36px',
                paddingLeft: '32px',
              }}
            >
              <SitueringTableMobile
                data={dataTable}
                pathInteractieveTool={pathInteractieveTool}
                highlightedRow={highlightedRow}
                setHighlightedRow={setHighlightedRow}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              minHeight={'160px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <p style={{ fontSize: '11px' }}>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </CardMedia>
    </Card>
  );
};
